
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.747 22.502c-2.068 0-3.75-1.682-3.75-3.75s1.682-3.75 3.75-3.75 3.75 1.682 3.75 3.75-1.682 3.75-3.75 3.75zm0-6c-1.241 0-2.25 1.009-2.25 2.25s1.009 2.25 2.25 2.25 2.25-1.009 2.25-2.25-1.01-2.25-2.25-2.25zM5.247 9.002c-2.068 0-3.75-1.682-3.75-3.75s1.682-3.75 3.75-3.75 3.75 1.682 3.75 3.75-1.682 3.75-3.75 3.75zm0-6c-1.241 0-2.25 1.009-2.25 2.25s1.009 2.25 2.25 2.25 2.25-1.009 2.25-2.25-1.01-2.25-2.25-2.25zM3.306 23.252c-.396 0-.783-.161-1.061-.442l-1.058-1.059a1.484 1.484 0 01-.439-1.057c-.001-.4.154-.777.436-1.06L19.627 1.19c.283-.282.66-.438 1.06-.438s.776.155 1.059.436l1.062 1.062c.58.585.581 1.536.002 2.119L4.368 22.812c-.276.279-.662.44-1.058.44h-.004zm-1.059-2.561l1.061 1.061 18.439-18.44-1.061-1.061-18.439 18.44z"}})])
          )
        }
      }
    